<div class="w-full flex flex-row items-center relative bg-background rounded-xl h-24">
    <fa-icon
        class="ml-2"
        [icon]="['fas', 'grip-vertical']" />
    <div class="flex flex-col justify-center ml-4">
        <span class="m-0 font-semibold text-base">{{ computedStatistic().name }}</span>
        @if (computedStatistic().description) {
            <p>{{ computedStatistic().description }}</p>
        }
    </div>
    <div class="absolute top-2 right-2">
        @if (isOwnerAndShared() || isPrivateStatistic()) {
            <fa-icon
                class="cursor-pointer px-1 hover:text-blue-500"
                [icon]="['far', 'sparkles']"
                [matTooltip]="'statistic.editStatistic' | transloco"
                (click)="openEditStatisticDialog()" />
        }
        <fa-icon
            class="px-1"
            [class]="trashIconConfig().className"
            [icon]="['fas', 'trash']"
            [matTooltip]="trashIconConfig().tooltip"
            [matTooltipDisabled]="!trashIconConfig().tooltip"
            (click)="!trashIconConfig().disabled && trashIconConfig().onClick()" />
    </div>
</div>
